// AddictionCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from '../Helmet';
const TITLE = "Kalkulator Dampak Kecanduan pada Kesehatan dan Harapan Hidup - Alat Berhenti";
const DESCRIPTION =
  "Kalkulator dampak kecanduan pada harapan hidup: temukan bagaimana rokok, alkohol, atau narkoba mengurangi tahun hidup Anda! Masukkan jenis kecanduan dan durasi paparan untuk menghitung dampak kesehatan - dengan tips berhenti dan data medis terpercaya.";
const KEYWORDS = "kecanduan, kehidupan, usia, rokok, alkohol";
const OG_URL = "https://do-calculate.com/calculator/id/addiction-calculator/";
function AddictionCalculator() {
  const [age, setAge] = useState(0);
  const [dailyDose, setDailyDose] = useState(0);
  const [addictionType, setAddictionType] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const addictionData = {
    Merokok: { yearsLost: 10, lifeExpectancy: 79 - 10 },
    Alkohol: { yearsLost: 23, lifeExpectancy: 79 - 23 },
    Kokain: { yearsLost: 34, doseEffect: 5.6, lifeExpectancy: 79 - 34 },
    Metadon: { yearsLost: 38, lifeExpectancy: 41 },
    Heroin: { yearsLost: 42, lifeExpectancy: 38 },
    Metamfetamin: { yearsLost: 42, doseEffect: 11, lifeExpectancy: 79 - 42 },
  };
  const handleCalculate = () => {
    try {
      if (age && dailyDose && addictionType) {
        const addiction = addictionData[addictionType];
        if (addiction) {
          const nonAddictLifeExpectancy = 79;
          const lifeExpectancy = addiction.lifeExpectancy;
          const yearsLost = nonAddictLifeExpectancy - lifeExpectancy;
          const totalDoseEffect = addiction.doseEffect
            ? dailyDose * addiction.doseEffect
            : 0;
          const addictionDuration =
            age > lifeExpectancy ? 0 : lifeExpectancy - age;
          const totalLifeLost = yearsLost + totalDoseEffect;
          setResult({
            nonAddictLifeExpectancy,
            lifeExpectancy,
            addictionDuration,
            totalLifeLost,
          });
        }
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menghitung harapan hidup berdasarkan jenis kecanduan dan jumlah dosis harian.
                </p>
                <p>
                  Pernahkah Anda bertanya-tanya tentang harga sebenarnya dari kecanduan? Alat ini membantu Anda memperkirakan beberapa dampak kesehatan potensial dari kecanduan dalam jangka panjang.{" "}
                  <strong>
                    Harap dicatat bahwa ini hanyalah perkiraan, dan harapan hidup dipengaruhi oleh banyak faktor.{" "}
                  </strong>
                  Kecanduan adalah penyakit yang kompleks, dan perawatan serta perawatan kesehatan dapat secara signifikan mengubah jalan hidup Anda.
                </p>
                <p>
                  Kecanduan mencuri lebih dari yang Anda bayangkan. Alat ini memberi Anda gambaran kasar tentang dampak kesehatan potensial dari kecanduan. Ingatlah bahwa harapan hidup hanyalah angka, dan kualitas hidup adalah yang terpenting. Pemulihan mungkin terjadi, jangan ragu untuk mencari bantuan.
                </p>
                <p>
                  <b>
                    Penting: Harus ditekankan bahwa kalkulator ini hanyalah alat bantu, dan tidak boleh diandalkan sebagai diagnosis medis. Jika Anda menderita masalah kecanduan, Anda harus berkonsultasi dengan dokter atau spesialis kesehatan mental.
                  </b>
                </p>
                <p>
                  Kalkulator dikembangkan berdasarkan{" "}
                  <a
                    href="https://www.dailymail.co.uk/health/article-2788399/how-years-drinking-drug-smoking-habits-shaving-life-terrifying-graphic-reveals-one-cigarette-cuts-14-minutes-alcoholic-drink-cost-7-hours.html"
                    rel="nofollow"
                  >
                    surat kabar Daily Mail Inggris
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="age">
                        Masukkan usia Anda
                      </label>
                      <input
                        id="age"
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="Masukkan usia Anda"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="dailyDose">
                        Jumlah dosis harian
                      </label>
                      <input
                        id="dailyDose"
                        type="number"
                        value={dailyDose}
                        onChange={(e) => setDailyDose(e.target.value)}
                        placeholder="Masukkan dosis harian"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        className="form-label ms-2"
                        htmlFor="addictionType"
                      >
                        Pilih jenis kecanduan
                      </label>
                      <select
                        id="addictionType"
                        value={addictionType}
                        onChange={(e) => setAddictionType(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">Pilih jenis kecanduan</option>
                        <option value="Merokok">Merokok</option>
                        <option value="Alkohol">Alkohol</option>
                        <option value="Kokain">Kokain</option>
                        <option value="Metadon">Metadon</option>
                        <option value="Heroin">Heroin</option>
                        <option value="Metamfetamin">Metamfetamin</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p>
                        Harapan hidup non-pemakai:{" "}
                        {result.nonAddictLifeExpectancy} tahun
                      </p>
                      <p>Harapan hidup pemakai: {result.lifeExpectancy} tahun</p>
                      <p>Durasi kecanduan: {result.addictionDuration} tahun</p>
                      <p>Total tahun yang hilang: {result.totalLifeLost} tahun</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Informasi Tambahan</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Kecanduan Zat:</h2>{" "}
                  </u>
                  <p>
                    Meliputi alkohol, narkoba (seperti kokain dan heroin), nikotin, dan obat-obatan.
                  </p>
                  <p>Kecanduan membuat seseorang tidak mampu meninggalkan zat-zat ini.</p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Bahaya Kecanduan:</h2>{" "}
                  </u>
                  <p>Kesehatan Fisik dan Mental:</p>
                  <ul>
                    <li>Kecanduan menyebabkan masalah kesehatan fisik dan mental.</li>
                    <li>
                      Dapat menyebabkan penurunan kesehatan umum dan penyakit kronis.
                    </li>
                  </ul>
                  <p>Hubungan Sosial:</p>
                  <ul>
                    <li>Kecanduan mempengaruhi hubungan keluarga dan sosial.</li>
                    <li>
                      Dapat menyebabkan isolasi dan keterasingan dari lingkungan sosial.
                    </li>
                  </ul>
                  <p>Masalah Keuangan:</p>
                  <ul>
                    <li>Kecanduan menghabiskan sumber daya keuangan.</li>
                    <li>Dapat menyebabkan utang dan kemiskinan.</li>
                  </ul>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default AddictionCalculator;